<template>
<transition name="slide">
  <el-dialog :class="['popups', 'sliding', popupTypeClass]" :modal-class="modalClass" :show-close="false" :visible.sync="visible" top="0px" width="800px" @open="open" @close="onClose" modal-append-to-body append-to-body :modal="true">
    <el-row slot="title" type="flex" justify="space-between">
      <el-col style="margin-top:-7px;">
        <span class="el-dialog__title" style="font-size: 23px;">
          <div>
            {{ userInfo.managerName }}
            <span style="font-size: 18px;margin-left:4px;color: #575560;">({{ userInfo.managerId }}/{{ userInfo.managerTypeName }})</span>
          </div>
          <div style="font-size: 13px;color: #575560;">
            마지막 로그인 시각: {{ lastLoginTime }}
          </div>
        </span>
      </el-col>
      <el-col :span="10" style="text-align: right;">
        <el-button size="medium" @click="logout">로그아웃</el-button>
      </el-col>
    </el-row>
    <div class="no-margin">
      <el-tabs type="border-card" v-model="activeTab">
        <el-tab-pane label="사용자 정보" name="accountInfo">
          <w-account-info-form :close-flag="visible" @onCancelPopup="visible=false"/>
        </el-tab-pane>
        <el-tab-pane :label="noticeTabName" name="notice">
          <w-notice-table ref="noticeView" :active-tab="activeTab" @update-unread-notice-count="updateUnreadNoticeCount" />
        </el-tab-pane>
        <el-tab-pane :label="messageTabName" name="message">
          <w-message-view ref="messageView" :active-tab="activeTab" @update-unread-message-count="updateUnreadMessageCount" />
        </el-tab-pane>
        <el-tab-pane name="alarmSetting">
          <span slot="label">알림 설정 <i v-if="isAlarmLock" class="far fa-lock-alt"></i></span>
          <w-alarm-setting-view :active-tab="activeTab" @onCancelPopup="visible=false" :is-alarm-lock="isAlarmLock" @release-alarm-lock="releaseAlarmLock" />
        </el-tab-pane>
        <el-tab-pane label="활동 기록" name="accessHist">
          <w-access-hist-tab :active-tab="activeTab" />
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- <div slot="footer">
        <slot name="footer" />
      </div> -->
  </el-dialog>
</transition>
</template>

<script>
import { isNil } from 'lodash';
import { mapGetters } from 'vuex';
import userApi from '@/api/frame/user';
import { EMPTY_TEXT } from '@/utils/string';
import { getDateToString } from '@/utils/date';
import msgUtil from '@/utils/message';
import { setVModalClassBySlidingType } from '@/utils/popup';
import WAccountInfoForm from './AccountInfoForm';
import WNoticeTable from './NoticeTable';
import WMessageView from './MessageView';
import WAccessHistTab from './AccessHistTab';
import WAlarmSettingView from './AlarmSettingView';

export default {
  name: 'WUserSlidingPopup',
  components: {
    WAccountInfoForm,
    WNoticeTable,
    WMessageView,
    WAccessHistTab,
    WAlarmSettingView,
  },
  data() {
    return {
      visible: false,
      activeTab: 'accountInfo',
      noticeTabName: '공지사항',
      messageTabName: '쪽지함',
      alarmLockInfo: null,
    };
  },
  computed: {
    showUserPopup() {
      return this.$store.state.popup.showUserPopup;
    },
    userPopupActiveTab() {
      return this.$store.state.popup.userPopupActiveTab;
    },
    bodyHeightClass() {
      if (isNil(this.$slots.footer)) {
        return 'no-footer';
      }
      return 'include-footer';
    },
    ...mapGetters(['userInfo']),
    lastLoginTime() {
      if (isNil(this.userInfo.lastLoginDatetime)) {
        return EMPTY_TEXT;
      }
      return getDateToString(this.userInfo.lastLoginDatetime);
    },
    isAlarmLock() {
      const alarmLockInfo = this.alarmLockInfo;
      if (!isNil(alarmLockInfo)) {
        if (alarmLockInfo.lockFlag === '1' && alarmLockInfo.currentCount >= alarmLockInfo.lockCount) {
          return true;
        }
      }
      return false;
    },
    popupTypeClass() {
      return this.$store.getters.showSettingView ? 'setting-sliding' : '';
    },
    modalClass() {
      return this.$store.getters.showSettingView ? 'setting-sliding' : 'sliding';
    },
  },
  watch: {
    showUserPopup: {
      immediate: true,
      handler(value) {
        if (value) {
          this.open();
        } else {
          this.close();
        }
      },
    },
    userPopupActiveTab: {
      handler(value) {
        if (!isNil(value)) {
          this.setActiveTab(value);
        }
      },
    },
  },
  methods: {
    open() {
      if (!isNil(this.userPopupActiveTab)) {
        this.setActiveTab(this.userPopupActiveTab);
      } else {
        this.activeTab = 'accountInfo';
      }
      // 공지사항 & 쪽지 Count 조회
      userApi.getUnreadNoticeCount().then((response) => {
        if (response.data.success) {
          this.updateUnreadNoticeCount(response.data.data);
        }
      });
      userApi.getUnreadMessageCount().then((response) => {
        if (response.data.success) {
          this.updateUnreadMessageCount(response.data.data);
        }
      });
      userApi.getAlarmLockInfo().then((response) => {
        if (response.data.success) {
          this.alarmLockInfo = response.data.data;
        }
      });
      setVModalClassBySlidingType();
      this.visible = true;
    },
    close() {
      this.visible = false;
    },
    onClose() {
      this.$refs.noticeView.showAddView = false;
      this.$refs.messageView.showMessageForm = false;
      this.alarmLockInfo = null;
      if (this.showUserPopup) {
        this.$store.dispatch('closeUserPopup');
      }
    },
    updateUnreadNoticeCount(count) {
      this.noticeTabName = `공지사항(${count})`;
    },
    updateUnreadMessageCount(count) {
      this.messageTabName = `쪽지함(${count})`;
    },
    releaseAlarmLock() {
      this.alarmLockInfo = null;
    },
    /**
     * 로그아웃 한다. (임시)
     * @author Ju
     * @return {[type]} [description]
     */
    logout() {
      this.$confirm(...msgUtil.getBasicConfirmData('로그아웃')).then(() => {
        this.$store.dispatch('logout').then((result) => {
          if (result === true) {
            this.$router.push({
              path: '/login',
            });
          }
        });
      });
    },
    /**
     * 사용자 팝업의 특정 탭을 강제로 활성화한다.
     * @author jeee12
     * @param  {[type]} tabName [description]
     */
    setActiveTab(tabName) {
      this.activeTab = tabName;
    },
  },
};
</script>

<style lang="scss">
.frame-table .tab-button {
  .el-tabs__content {
    height: calc(100% - 30px);
    padding-top: 12px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/frame/components/popup/UserSlidingPopup.vue